import React, { useState, useEffect } from "react";
import api from "../../api";

// challenge goals by key
const goalByKey = {
  catch_pokemon100:       100,
  catch_shinies5_any:      5,
  catch_shinies5_specific: 5,
  pokedex_new:             1,
  beat_train5:             5,
  beat_wild25:            25,
  shard5_any:              5,
  shard5_spec:             5,
  use_mining_potion:       1,
  use_drop_potion:         1,
  use_ultra_lure2:         2,
  sell_pokemon100:        100,
  collect_gold10:         10,
  collect_gems15:         15,
  collect_diamonds5:       5,
  collect_rocks50:           50
};

// rewards by tier
const rewards = {
  tier1: [
    { name: 'Drop Potion',    img: '/items/droplure.png',   chance: '65%' },
    { name: 'Mining Potion',  img: '/items/mininglure.png', chance: '65%' },
    { name: 'Bronze Safe',    img: '/items/bronzesafe.png', chance: '65%' },
    { name: 'Ultra Lure',     img: '/items/ultralure.png',  chance: '65%' },
    { name: 'TM 25 (Ember)',     img: '/items/firetm.png',  chance: '65%' },
    { name: 'TM 12 (Water Gun)',     img: '/items/watertm.png',  chance: '65%' },
    { name: 'TM 02 (Vine Whip)',     img: '/items/grasstm.png',  chance: '65%' },
    { name: 'Safe',           img: '/items/safe.png',        chance: '65%' },
    { name: 'Ruby Gummy',           img: '/items/ruby-gummy.png',        chance: '65%' },
    { name: 'Sapphire Gummy',           img: '/items/sapphire-gummy.png',        chance: '65%' },
    { name: 'Emerald Gummy',           img: '/items/emerald-gummy.png',        chance: '65%' },
    { name: 'Golden Gummy',           img: '/items/golden-gummy.png',        chance: '65%' },
    { name: 'Diamond Gummy',           img: '/items/diamond-gummy.png',        chance: '65%' },
  ],
  tier2: [
    { name: 'Golden Safe',    img: '/items/goldensafe.png',  chance: '30%' },
    { name: 'Shiny Charm',    img: '/items/shinycharm.png',  chance: '30%' },
    { name: 'Golden Box',     img: '/items/goldenbox.png',   chance: '30%' },
    { name: 'Ruby Box',     img: '/items/RubyBox.png',   chance: '30%' },
     { name: 'Sapphire Box',     img: '/items/SapphireBox.png',   chance: '30%' },
     { name: 'Emerald Box',     img: '/items/EmeraldBox.png',   chance: '30%' },
     { name: 'Shadow Box',     img: '/items/shadowbox.png',   chance: '30%' },
     { name: 'Ruby Helmet',     img: '/items/ruby-helm.png',   chance: '30%' },
     { name: 'Sapphire Helmet',     img: '/items/sapphire-helm.png',   chance: '30%' },
  ],
  tier3: [
    { name: 'Exp Share', img: '/items/expshare.png',  chance: '5%' },
    { name: 'Amulet of Catching', img: '/items/amuletcatch.png',  chance: '5%' },
    { name: 'Emerald Helmet',     img: '/items/emerald-helm.png',   chance: '5%' },
    { name: 'Golden Helmet',     img: '/items/gold-helm.png',   chance: '5%' },
    { name: 'Ruby Crown',     img: '/items/rubycrown.png',   chance: '5%' },
    { name: 'Sapphire Crown',     img: '/items/sapphirecrown.png',   chance: '5%' },
    { name: 'Diamond Box',     img: '/items/diamondbox.png',   chance: '5%' },
    { name: 'Amulet of Mining',   img: '/items/amuletmine.png',   chance: '5%' },
  ]
};

const WeeklyChallenges = () => {
  document.title = "Weekly Missions | Pokémon Radiance";

  const [challenges, setChallenges] = useState([]);
  const [weekStart, setWeekStart]   = useState("");
  const [loading, setLoading]       = useState(true);
  const [error, setError]           = useState(null);

  // reward rotation state for preview
  const [idx1, setIdx1] = useState(0);
  const [idx2, setIdx2] = useState(0);
  const [idx3, setIdx3] = useState(0);

  // claim state
  const [claiming, setClaiming] = useState(false);
  const [claimedReward, setClaimedReward] = useState(null);
  const [displayImage, setDisplayImage] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [claimError, setClaimError] = useState("");


  const [switching, setSwitching] = useState(false);
  const [switchingMissionId, setSwitchingMissionId] = useState(null);
  const [userCurrency, setUserCurrency] = useState({ coins: 0 });

  useEffect(() => {
    setLoading(true);
    setError(null);
    Promise.all([
      api.get("/v1/weekly-reward-details", { withCredentials: true }),
      api.get("/v1/currency", { withCredentials: true })
    ])
      .then(([challengesRes, currencyRes]) => {
        setWeekStart(challengesRes.data.week_start);

        setChallenges(challengesRes.data.challenges);
        const currencyData = Array.isArray(currencyRes.data) ? currencyRes.data[0] : currencyRes.data;
        setUserCurrency({ coins: currencyData.coins || 0 });
      })
      .catch(() => setError("Failed to load weekly challenges"))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const t1 = setInterval(() => setIdx1(i => (i + 1) % rewards.tier1.length), 3000);
    const t2 = setInterval(() => setIdx2(i => (i + 1) % rewards.tier2.length), 3000);
    const t3 = setInterval(() => setIdx3(i => (i + 1) % rewards.tier3.length), 3000);
    return () => {
      clearInterval(t1);
      clearInterval(t2);
      clearInterval(t3);
    };
  }, []);

  const renderIcon = (ch) => {
    const { key, params } = ch;

    switch (key) {
      case "catch_pokemon100":
        return (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <img src="/sprites/Mew.png" alt="Pokémon" style={{ width: 48 }} />
            <img 
              src="/items/pokeball.png" 
              alt="Pokéball" 
              style={{ 
                position: 'absolute', 
                bottom: -5, 
                right: -5, 
                width: 20, 
                height: 20 
              }} 
            />
          </div>
        );
      case "catch_shinies5_any":
        return (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <img src="/sprites/ShinyCharizard.png" alt="Shiny Pokémon" style={{ width: 48 }} />
            <img 
              src="/items/pokeball.png" 
              alt="Pokéball" 
              style={{ 
                position: 'absolute', 
                bottom: -5, 
                right: -5, 
                width: 20, 
                height: 20 
              }} 
            />
          </div>
        );
      case "catch_shinies5_specific":
        // Get the species from params, or fall back to pikachu if not available
        const species = params?.species?.toLowerCase() || "pikachu";
        return (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <img 
              src={`/sprites/Shiny${species}.png`} 
              alt={`Shiny ${params?.species || 'Pokémon'}`} 
              style={{ width: 48 }} 
              onError={(e) => {
                // If the specific sprite fails to load, fall back to pikachu
                console.log(`Failed to load sprite for ${species}, falling back to pikachu`);
                e.target.src = "/sprites/pikachu.png";
              }}
            />
            <img 
              src="/items/pokeball.png" 
              alt="Pokéball" 
              style={{ 
                position: 'absolute', 
                bottom: -5, 
                right: -5, 
                width: 20, 
                height: 20 
              }} 
            />
          </div>
        );
      case "pokedex_new":
        return <img src="/items/pokedex.png" alt="Pokédex" style={{ width: 48 }} />;
      case "collect_gold10":
        return <img src="/items/gold.png" alt="Gold" style={{ width: 32 }} />;
      case "collect_diamonds5":
        return <img src="/items/diamond.png" alt="Diamond" style={{ width: 32 }} />;
      case "collect_gems15":
        return <img src="/items/emerald.png" alt="Emerald" style={{ width: 32 }} />;
      case "beat_train5":
        // Show a variety of trainer avatars
        const trainerAvatars = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        const randomTrainer = trainerAvatars[Math.floor(Math.random() * trainerAvatars.length)];
        return <img src={`/avatars/${randomTrainer}.png`} alt="Trainer" style={{ width: 48 }} />;
      case "beat_wild25":
        // Show a variety of popular Pokemon
        const wildPokemon = ['Pikachu', 'Charmander', 'Squirtle', 'Bulbasaur', 'Eevee', 'Growlithe', 'Psyduck', 'Geodude'];
        const randomPokemon = wildPokemon[Math.floor(Math.random() * wildPokemon.length)];
        return <img src={`/sprites/${randomPokemon}.png`} alt="Wild Pokemon" style={{ width: 48 }} />;
      case "shard5_any":
        // Show a single shard to represent "any shard" collection
        return <img src="/items/Red Shard.png" alt="Any Shard" style={{ width: 32 }} />;
      case "shard5_spec":
        // Display the specific shard type with better image mapping
        const shardImageMap = {
          'Red Shard': 'Red Shard.png',
          'Blue Shard': 'Blue Shard.png', 
          'Green Shard': 'Green Shard.png',
          'Purple Shard': 'Purple Shard.png',
          'White Shard': 'White Shard.png',
          'Ghost Shard': 'Ghost Shard.png',
          'Dark Shard': 'Dark Shard.png'
        };
        const shardType = params?.shard_type || 'Red Shard';
        const shardImage = shardImageMap[shardType] || 'Red Shard.png';
        return <img src={`/items/${shardImage}`} alt={shardType} style={{ width: 32 }} />;
      case "use_mining_potion":
        return <img src="/items/mininglure.png" alt="Mining Potion" style={{ width: 32 }} />;
      case "use_drop_potion":
        return <img src="/items/droplure.png" alt="Drop Potion" style={{ width: 32 }} />;
      case "use_ultra_lure2":
        return <img src="/items/ultralure.png" alt="Ultra Lure" style={{ width: 32 }} />;
      case "sell_pokemon100":
        return <img src="/avatars/20.png" alt="Sabrina" style={{ width: 48 }} />;
      case "collect_rocks50":
        return <img src="/items/rock-map.png" alt="rock" style={{ width: 48 }} />;
      default:
        console.error('Unknown challenge key:', key, 'Available keys in goalByKey:', Object.keys(goalByKey));
        return <img src="/items/question.png" alt="?" style={{ width: 48 }} />;
    }
  };

  if (loading) return <p style={{ color: "#fff" }}>Loading weekly challenges…</p>;
  if (error)   return <p style={{ color: "red" }}>{error}</p>;

  const expiration = new Date(new Date(weekStart).getTime() + 7 * 24 * 60 * 60 * 1000);
  const allCompleted = challenges.every(ch => ch.is_completed);

  const handleClaim = () => {
    if (!allCompleted || claiming || claimedReward) return;
    setClaiming(true);
    setClaimError("");
    api.post('/v1/weekly-reward-claim', {}, { withCredentials: true })
      .then(res => {
        const { tier, reward } = res.data;
        const tierList = rewards[tier];
        let interval = setInterval(() => {
          const rand = tierList[Math.floor(Math.random()*tierList.length)];
          setDisplayImage(rand.img);
          setPopupMessage("Spinning reward...");
        }, 200);
        setTimeout(() => {
          clearInterval(interval);
          const matched = tierList.find(r => r.name === reward.name);
          setDisplayImage(matched ? matched.img : tierList[0].img);
          setPopupMessage(`You received: ${reward.name}`);
          setClaimedReward(reward);
          setClaiming(false);
        }, 3000);
      })
      .catch(err => {
        const msg = err.response?.data?.detail || 'Claim failed';
        setClaimError(msg);
        setPopupMessage(msg);
        setClaiming(false);
      });
  };

  const handleSwitchMission = (missionId) => {
    if (userCurrency.coins < 500 || switching) return;
    
    setSwitching(true);
    setSwitchingMissionId(missionId);
    
    api.post('/v1/weekly-mission-switch', { mission_id: missionId }, { withCredentials: true })
      .then(res => {
        // Refresh the challenges data
        return Promise.all([
          api.get("/v1/weekly-reward-details", { withCredentials: true }),
          api.get("/v1/currency", { withCredentials: true })
        ]);
      })
      .then(([challengesRes, currencyRes]) => {
        setChallenges(challengesRes.data.challenges);
        const currencyData = Array.isArray(currencyRes.data) ? currencyRes.data[0] : currencyRes.data;
        setUserCurrency({ coins: currencyData.coins || 0 });
        setPopupMessage("Mission switched successfully!");
      })
      .catch(err => {
        const msg = err.response?.data?.detail || 'Failed to switch mission';
        setClaimError(msg);
        setPopupMessage(msg);
      })
      .finally(() => {
        setSwitching(false);
        setSwitchingMissionId(null);
      });
  };

  return (
  <div
    className="page-content"
    style={{ 
      background: "#1d222e", 
      minHeight: "100vh", 
      padding: "10px 5px",
      paddingTop: "70px", /* Add padding for the navbar height */
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      overflow: 'auto',
      marginTop: "70px" /* Add margin for the navbar height */
    }}
  >
    <style>{`
      .weekly-missions-modal {
        width: 95%;
        max-width: 1000px;
        margin-top: 20px;
        margin-bottom: 20px;
        height: auto;
        max-height: calc(100vh - 40px);
        background: rgba(29, 34, 46, 0.95);
        color: #fff;
        border-radius: 12px;
        backdrop-filter: blur(10px);
        border: 2px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
        overflow: hidden;
        display: flex;
        flex-direction: column;
      }
      .weekly-header {
        padding: 16px 16px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        background: rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 8px;
        position: sticky;
        top: 0;
        z-index: 10;
      }
      .weekly-content {
        padding: 16px;
        overflow-y: auto;
        flex: 1;
      }
      @media (max-width: 768px) {
          max-width: 1000px;
          margin-top: 20px;
          margin-bottom: 20px;
          height: auto;
          max-height: calc(100vh - 40px);
          background: rgba(29, 34, 46, 0.95);
          color: #fff;
          border-radius: 12px;
          backdrop-filter: blur(10px);
          border: 2px solid rgba(255, 255, 255, 0.1);
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }
        .weekly-header {
          padding: 16px 16px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          background: rgba(0, 0, 0, 0.2);
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 8px;
          position: sticky;
          top: 0;
          z-index: 10;
        }
        .weekly-content {
          padding: 16px;
          overflow-y: auto;
          flex: 1;
        }
        @media (max-width: 768px) {
          .weekly-content {
            padding: 12px;
          }
          .mission-card {
            padding: 12px !important;
          }
          .weekly-header {
            padding: 12px;
          }
        }
        @media (max-width: 576px) {
          .weekly-header {
            flex-direction: column;
            align-items: flex-start;
          }
          .mission-card > div:first-child {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 8px !important;
          }
          .mission-card > div:first-child > div:nth-child(2) {
            margin-bottom: 8px;
          }
        }
        .mission-card {
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 8px;
          padding: 16px;
          margin-bottom: 12px;
          transition: all 0.2s ease;
          position: relative;
        }
        .mission-card:hover {
          background: rgba(255, 255, 255, 0.08);
          border-color: rgba(255, 255, 255, 0.2);
          transform: translateY(-2px);
        }
        .mission-card.completed {
          background: rgba(40, 167, 69, 0.1);
          border-color: rgba(40, 167, 69, 0.3);
        }
        .reward-tier {
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 8px;
          padding: 16px;
          text-align: center;
          transition: all 0.2s ease;
        }
        .reward-tier:hover {
          background: rgba(255, 255, 255, 0.08);
          transform: translateY(-2px);
        }
        .progress-bar {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 10px;
          height: 8px;
          overflow: hidden;
          margin: 8px 0;
        }
        .progress-fill {
          background: linear-gradient(90deg, #28a745, #20c997);
          height: 100%;
          border-radius: 10px;
          transition: width 0.3s ease;
        }
        .currency-badge {
          display: flex;
          align-items: center;
          gap: 6px;
          background: rgba(255, 193, 7, 0.2);
          padding: 6px 12px;
          border-radius: 6px;
          font-size: 14px;
          font-weight: 500;
        }
        .switch-btn {
          background: rgba(255, 193, 7, 0.2);
          border: 1px solid rgba(255, 193, 7, 0.4);
          color: #ffc107;
          padding: 6px 12px;
          border-radius: 6px;
          font-size: 12px;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .switch-btn:hover:not(:disabled) {
          background: rgba(255, 193, 7, 0.3);
          transform: translateY(-1px);
        }
        .switch-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        .claim-btn {
          background: linear-gradient(135deg, #28a745, #20c997);
          border: none;
          color: white;
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          width: 100%;
        }
        .claim-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
        }
        .claim-btn:disabled {
          background: rgba(255, 255, 255, 0.1);
          cursor: not-allowed;
        }
      `}</style>
      
      <div className="weekly-missions-modal">
        {/* Header */}
        <div className="weekly-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <h3 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold', color: '#fff' }}>
              Weekly Missions
            </h3>
          </div>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
            <div style={{ color: '#ccc', fontSize: '14px', textAlign: 'right' }}>
              <div>Week of: {new Date(weekStart).toLocaleDateString()}</div>
              <div>Expires: {expiration.toLocaleDateString()}</div>
            </div>
            <div className="currency-badge">
              <img src="/items/coin.png" alt="Coins" style={{ width: 18, height: 18 }} />
              <span>{userCurrency.coins.toLocaleString()}</span>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="weekly-content">
          {/* Mission Overview */}
          <div style={{ 
            background: 'rgba(255, 255, 255, 0.05)', 
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '8px',
            padding: '16px',
            marginBottom: '24px'
          }}>
            <h5 style={{ color: '#fff', margin: '0 0 8px 0' }}>Mission Overview</h5>
            <p style={{ color: '#ccc', margin: '0 0 12px 0', fontSize: '14px' }}>
              Complete all 4 missions to earn a reward! Switch any mission for 500 coins.
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
              <span style={{ color: '#28a745', fontWeight: '600' }}>
                {challenges.filter(ch => ch.is_completed).length}/4 Completed
              </span>
              <span style={{ color: '#ffc107' }}>Tier 1: 60% • Tier 2: 30% • Tier 3: 10%</span>
            </div>
          </div>

          {/* Rewards Section */}
          <div style={{ marginBottom: '24px' }}>
            <h5 style={{ color: '#fff', margin: '0 0 16px 0' }}>Available Rewards</h5>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '12px' }}>
              {['tier1','tier2','tier3'].map((tierKey, i) => {
                const tierList = rewards[tierKey];
                const idx = [idx1, idx2, idx3][i];
                const { name, img, chance } = tierList[idx];
                return (
                  <div key={tierKey} className="reward-tier">
                    <div style={{ color: '#ffc107', fontWeight: '600', marginBottom: '8px' }}>
                      Tier {i+1} ({chance})
                    </div>
                    <img src={img} alt={name} style={{ width: 40, height: 40, marginBottom: '8px' }} />
                    <div style={{ color: '#fff', fontSize: '14px', fontWeight: '500' }}>{name}</div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Missions Section */}
          <div style={{ marginBottom: '24px' }}>
            <h5 style={{ color: '#fff', margin: '0 0 16px 0' }}>Your Missions</h5>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {challenges.map((challenge, index) => {
                const goal = goalByKey[challenge.key] || 1;
                const progress = Math.min(challenge.progress, goal);
                const progressPercent = (progress / goal) * 100;
                const isCompleted = challenge.is_completed;
                const isSwitching = switchingMissionId === challenge.assignment_id;
                


                return (
                  <div 
                    key={index} 
                    className={`mission-card ${isCompleted ? 'completed' : ''}`}
                  >
                    {isCompleted && (
                      <div style={{
                        position: 'absolute',
                        top: '12px',
                        right: '12px',
                        background: '#28a745',
                        color: '#fff',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '11px',
                        fontWeight: 'bold'
                      }}>
                        ✓ COMPLETE
                      </div>
                    )}
                    
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '12px' }}>
                      <div style={{ flexShrink: 0 }}>
                        {renderIcon({ key: challenge.key, params: challenge.params })}
                      </div>
                      <div style={{ flex: 1 }}>
                        <h6 style={{ color: '#fff', margin: '0 0 4px 0', fontSize: '16px', fontWeight: '600' }}>
                          {challenge.name}
                        </h6>
                        <p style={{ color: '#ccc', margin: 0, fontSize: '14px' }}>
                          {challenge.description}
                        </p>
                      </div>
                      {!isCompleted && (
                        <button
                          className="switch-btn"
                          onClick={() => handleSwitchMission(challenge.assignment_id)}
                          disabled={userCurrency.coins < 500 || isSwitching}
                          style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
                        >
                          {isSwitching ? 'Switching...' : (
                            <>
                              Switch (500 <img src="/items/coin.png" alt="coins" style={{ width: 12, height: 12 }} />)
                            </>
                          )}
                        </button>
                      )}
                    </div>
                    
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                        <span style={{ color: '#ccc', fontSize: '14px' }}>Progress</span>
                        <span style={{ color: '#fff', fontSize: '14px', fontWeight: '600' }}>
                          {progress}/{goal}
                        </span>
                      </div>
                      <div className="progress-bar">
                        <div 
                          className="progress-fill" 
                          style={{ width: `${progressPercent}%` }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Claim Reward Section */}
          {allCompleted && !claimedReward && (
            <div style={{
              background: 'rgba(40, 167, 69, 0.1)',
              border: '1px solid rgba(40, 167, 69, 0.3)',
              borderRadius: '8px',
              padding: '20px',
              textAlign: 'center',
              marginBottom: '16px'
            }}>
              <h5 style={{ color: '#28a745', margin: '0 0 12px 0' }}>🎉 All Missions Complete!</h5>
              <p style={{ color: '#ccc', margin: '0 0 16px 0' }}>You've completed all weekly missions. Claim your reward!</p>
              <button
                className="claim-btn"
                onClick={handleClaim}
                disabled={claiming}
              >
                {claiming ? 'Claiming Reward...' : 'Claim Weekly Reward'}
              </button>
            </div>
          )}

          {/* Claim Error */}
          {claimError && (
            <div style={{
              background: 'rgba(220, 53, 69, 0.1)',
              border: '1px solid rgba(220, 53, 69, 0.3)',
              borderRadius: '8px',
              padding: '12px',
              color: '#dc3545',
              textAlign: 'center',
              marginBottom: '16px'
            }}>
              {claimError}
            </div>
          )}

          {/* Claim Animation */}
          {displayImage && (
            <div style={{
              background: 'rgba(255, 255, 255, 0.05)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '8px',
              padding: '20px',
              textAlign: 'center'
            }}>
              <img src={displayImage} alt="Reward" style={{ width: 64, height: 64, marginBottom: '12px' }} />
              <div style={{ color: '#fff', fontSize: '16px', fontWeight: '500' }}>{popupMessage}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WeeklyChallenges;
